import { Injectable, Injector } from '@angular/core';
import { Router, ActivatedRoute, ResolveEnd, ActivatedRouteSnapshot, RouterEvent } from '@angular/router';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { map, filter } from 'rxjs/operators';

@Injectable()
export class AppInsightService {
    
    private appInsights: ApplicationInsights;

    private routerSubscription: Subscription;

    constructor(private injector: Injector
        ) {
        this.appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: environment.instrumentationKey
            }
        });
        this.appInsights.loadAppInsights();

        const router = this.injector.get(Router);

        this.routerSubscription = router.events.pipe(
            filter(e => e instanceof ResolveEnd)
            ).subscribe((e: ResolveEnd) => {
            const activatedComponent = this.getActivatedComponent(e.state.root);
            if (activatedComponent) {
                this.logPageView(`${activatedComponent.name} ${this.getRouteTemplate(e.state.root)}`, e.urlAfterRedirects);
            }
            });
    }

    logPageView(
        name?: string,
        url?: string,
        properties?: any,
        measurements?: any,
        duration?: number
    ) {
        if (duration) {
            measurements = measurements || {};
            measurements['duration'] = duration;
        }
        this.appInsights.trackPageView({
            name: name,
            uri: url,
            properties: properties,
            measurements: measurements
        });
    }

    logEvent(name: string, properties?: any, measurements?: any) {
        this.appInsights.trackEvent({
            name: name,
            properties: properties,
            measurements: measurements
        });
    }

    logException(
        exception: Error,
        handledAt?: string,
        properties?: any,
        measurements?: any
    ) {
        if (handledAt) {
            properties = properties || {};
            properties['handledAt'] = handledAt;
        }
        this.appInsights.trackException({
            exception: exception,
            properties: properties,
            measurements: measurements
        });
    }

    logTrace(message: string, properties?: any, severityLevel?: any) {
        this.appInsights.trackTrace({
            message: message,
            properties: properties,
            severityLevel: severityLevel
        });
    }
    
    setAuthenticatedUserId(userId: string): void {
        this.appInsights.setAuthenticatedUserContext(userId);
    }

    clearAuthenticationContext() :void
    {
        this.appInsights.clearAuthenticatedUserContext();
    }

    private getActivatedComponent(snapshot: ActivatedRouteSnapshot): any {

        if (snapshot.firstChild) {
            return this.getActivatedComponent(snapshot.firstChild);
        }

        return snapshot.component;
    }

    private getRouteTemplate(snapshot: ActivatedRouteSnapshot): string {
        let path = '';
        if (snapshot.routeConfig) {
            path += snapshot.routeConfig.path;
        }

        if (snapshot.firstChild) {
            return path + this.getRouteTemplate(snapshot.firstChild);
        }

        return path;
    }

    private AddGlobalProperties(properties?: { [key: string]: string }): { [key: string]: string } {
        if (!properties) {
            properties = {};
        }

        //add your custom properties such as app version

        return properties;
    }
}